import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { FileService } from '../services/file.service';
import { Documento, AttachmentDto, ProcessoRiferimento, DocumentiEqualtecResult, DocumentiEqualtecResultObject, LegalEntityEprocessiRiferimentoResult, Evidenza, Link } from '../models/data.model';
import { DataService } from '../services/data.service';
import { CommonService } from '../services/common.service';
import { MimetypeService } from '../services/mimetype.service';
import { TranslateService } from '@ngx-translate/core';
import { Placeholder } from '@angular/compiler/src/i18n/i18n_ast';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';


import { ToastrService } from 'ngx-toastr';
import { AuthGuardService } from '../services/authGuard';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ElementRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  FormBuilder,
  FormGroup,
  Validators,
  NgForm
} from '@angular/forms';
import { ModalService } from '../services/modal.service';
import { PresaVisioneModalService } from '../services/presa-visione-modal.service';

@NgModule({
  imports: [BrowserModule, FormsModule],
})

@Component({
  selector: 'app-equaltec',
  templateUrl: './equaltec-detail.component.html',
  styleUrls: ['./equaltec-detail.component.css']
})
export class EqualtecdetailComponent implements OnInit {

  @ViewChild('fileUpload') myInputVariable: ElementRef;


  @ViewChild('Or') OrElement;
  @ViewChild('And') AndElement;

  @ViewChild('DynamicForm') DynamicFormElement;
  @ViewChild('DynamicInput') DynamicInputElement;

  constructor(private tipologiService: FileService,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private documentService: CommonService<Documento>,
    private evidenzaService: CommonService<Evidenza>,
    private linkService: CommonService<Link>,
    private creaEvidenzaService: CommonService<string>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private modalService: ModalService,
    public translate: TranslateService,
    private toastr: ToastrService,
    private authService: AuthGuardService,
    private router: Router,
    private http: HttpClient,
    private presaVisioneModalService: PresaVisioneModalService


  ) {
    this.checkIfLogin();
  }

  srch: Documento = null;

  public equaltecFilter: any = '';
  processi: ProcessoRiferimento[] = [];

  sottoprocessi: string[] = [];

  documentiEqualtecResult: DocumentiEqualtecResult[] = [];
  documentiEqualtecResultProcess: DocumentiEqualtecResult[] = [];
  documentiEqualtecResultGuideline: DocumentiEqualtecResult[] = [];
  documents: Documento[] = [];
  evidenze: Evidenza[] = [];
  documentiCollegati: Documento[] = [];
  evidenzeRevPrecedente: Evidenza[] = [];
  labelNoRecord: boolean = false;
  isUnderlined: string;
  isTabellaDetailConUnElemento: boolean = true;
  isExpandedDetail: boolean = false;
  isTabellaDetailRevisionPending: boolean = false;
  isTabellaLinkRevisionPending: boolean = false;

  docApertiDetail: number = 0;
  paginaEvidenzeRevPrecedente: boolean = false;


  idDoc: string;

  isUtenteChiamante = true;
  document: Documento;
  loaded = false;
  loadedLogin = false;
  id: string;
  idallegato: string;
  idutente: string;

  selected: any = {
    item: null,
    model: null,
    classification: null
  }
  isUserloggedIn: boolean = false;
  public profile: any = null;


  calendarModel: NgbDateStruct;
  isCalendar: boolean = false;

  isDetail: boolean = true;
  isOkDescrizione: boolean = true;
  isOkOggetto: boolean = true;
  paginaEvidenze: boolean = false;
  paginaDocCollegati: boolean = false;
  paginaDescrizioneDocumentoCorrente: string = "";
  paginaIDDocumentoCorrente: string = "";
  paginaCommittenteDocumentoCorrente: string = "";

  isTabellaLinkConUnElemento: boolean = false;
  isExpandedLink: boolean = false;
  docApertiLink: number = 0;
  selectedDate: Date;
  isEvidenzAccettata: boolean = false;


  DescrizioneEvidenza: string;
  OggettoEvidenza: string;
  searchFullTextEvidenze: string;
  buttonEvidenzaActive: boolean = true;



  /* Cliccando sul link della notifica si arriva al direttamente al dettaglio del documento (gestito dal presente componente)
  * Se l'utente è loggato accede, altrimenti deve eseguire la login (in questo caso l'url è xxxx\login\id)
  */

  ngOnInit() {
    if (this.isUserloggedIn) {
      this.idDoc = this.activatedRoute.snapshot.paramMap.get('id');
      console.log("this.idDoc" + this.idDoc);
    };



    console.log(this.idutente);
    this.loadedLogin = true;

    // Questo è veramente un casino:
    // quanto viene caricato service-ita.component tramite il routing personale del modulo, si inserisce nel dataService il nome del titolo del componente
    // a questo ComponentInput si sottoscrive il padre di di service-ita, cioè custom-layout.component, che renderizza il titolo in alto
    this.dataService.ComponentInput = '';
  }

  checkIfLogin = () => {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let d = event.url.split('/');
        let m = d[d.length - 1];
        let n = d[d.length - 2];
        if (m != 'login') {
          this.authService.ImLogged(m, n).then(
            (result) => {
              if (result) {
                console.log("Entra primo login  2?");
                this.isUserloggedIn = true;
                this.profile = this.authService.getProfile();
                if (this.loadedLogin == true) {
                  this.activatedRoute.params.subscribe(p => {
                    this.id = p['id'];
                  });
                  this.activatedRoute.queryParams.subscribe(params => {
                    this.idutente = params.idutente;
                    this.idallegato = params.idallegato;
                  });
                  this.checkUtenteLoggato(this.idutente, this.id);
                }
              }
            },
            (error) => console.log('error')
          );
        }
      }
    });
  }


  checkUtenteLoggato(idutente: string, iddocumento: string) {
    let input = {};
    if (idutente == undefined) {
      input = { idutente: 0, iddocumento: iddocumento };
    } else {
      input = { idutente: idutente, iddocumento: iddocumento };
    }
    const url = 'api/rest/checkUtenteLoggato';
    this.documentService.postData(url, input, false).subscribe(result => {
      console.log(result)
      if (result['result'] == 'true') {
        this.getEqualtecDocument(iddocumento);
        this.isUtenteChiamante = true;
      } else {
        this.isUtenteChiamante = false;
      }
    }, error => console.error('error ', error));
  }

  getEqualtecDocument(iddocumento) {
    this.labelNoRecord = false;

    const url = 'api/rest/getEqualtecDocument';
    const input = { iddocumento: iddocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is document : ', result);
        const document = result as Documento;
        this.document = document;
        this.documents.push(document);

        this.documents.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = 'Open detail';
          if (d.isNewRevisionPending) {
            this.isTabellaDetailRevisionPending = true;
          }
        });
        this.labelNoRecord = true;
      }
    }, error => console.error('error ', error));
  }

  apriPaginaEvidenze = (idDocumento, descrizioneDocumento, committente) => {
    this.labelNoRecord = false;

    this.isDetail = false;
    this.paginaEvidenze = true;
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;
    this.paginaIDDocumentoCorrente = idDocumento;
    this.paginaCommittenteDocumentoCorrente = committente;
    console.log(this.paginaCommittenteDocumentoCorrente);
    console.log('GetEvidenzeByIdDocumento');
    const url = 'api/rest/GetEvidenzeByIdDocumento';

    const input = { iddocumento: idDocumento };
    this.evidenzaService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is evidenze : ', result);
        this.evidenze = result as Evidenza[];
        this.evidenze.forEach(evi => {
          if (evi['stato'] === 2) {
            this.isEvidenzAccettata = true;
          }
        });
        this.labelNoRecord = true;
      }
    });
  }

  chiudiPaginaEvidenzeEDocCollegati = () => {
    this.isDetail = true;
    this.paginaEvidenze = false;
    this.paginaEvidenzeRevPrecedente = false;
    this.paginaDocCollegati = false;
  }

  apriPaginaEvidenzeRevPrecedente = (idDocumento, descrizioneDocumento, committente) => {
    this.labelNoRecord = false;
    this.isDetail = false;
    this.paginaEvidenzeRevPrecedente = true;
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;
    this.paginaIDDocumentoCorrente = idDocumento;
    this.paginaCommittenteDocumentoCorrente = committente;
    const url = 'api/rest/GetEvidenzeRevPrecedenteByIdDocumento';
    const input = { iddocumento: idDocumento };
    this.evidenzaService.postData(url, input, false).subscribe(result => {
      if (result) {
        this.evidenzeRevPrecedente = result as Evidenza[];
        this.evidenzeRevPrecedente.forEach(evi => {
          if (evi['stato'] === 2) {
            this.isEvidenzAccettata = true;
          }
        });
        this.labelNoRecord = true;
      }
    });
  }

  apriPaginaDocCollegati = (idDocumento, descrizioneDocumento) => {
    this.labelNoRecord = false;

    this.isDetail = false;
    this.paginaDocCollegati = true;
    this.paginaDescrizioneDocumentoCorrente = descrizioneDocumento;

    console.log('GetDocumentiCollegatiByIdDocumento');
    const url = 'api/rest/GetDocumentiCollegatiByIdDocumento';

    const input = { iddocumento: idDocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is documents : ', result);
        this.documentiCollegati = result as Documento[];
        this.documentiCollegati.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = 'Open detail';
          if (d.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
        });
        this.labelNoRecord = true;
      }
    });
  }

  returnToHome() {
    this.router.navigate(['/'])
  }

  returnBack() {
    this.isDetail = true;
    this.paginaEvidenze = false;
    this.paginaEvidenzeRevPrecedente = false;
    this.paginaDocCollegati = false;
  }

  documentDetail = (apridettaglio, descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline) => {
    if (apridettaglio === 'Open detail') {
      this.openDocumentDetail(descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    } else {
      this.closeDocumentDetail(descr, codice, tipodocumento, revisione, identificazioneDocumento, processOGuideline);
    }
  }

  openDocumentDetail = (descr, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case 'detail': {
        this.docApertiDetail++;
        let documentiAperti = 0;
        this.isExpandedDetail = true;

        this.documents.forEach(doc => {
          console.log(doc.isNewRevisionPending)
          if (doc.isNewRevisionPending) {
            this.isTabellaDetailRevisionPending = true;
          }
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documents.length > 1) {
              const y = { key: '', value: '' };
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaDetailRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaDetailConUnElemento = true;
            }
            doc.apriDettaglio = 'Close detail';
          }
        })
        this.documents.forEach(doc => {
          if (doc.apriDettaglio === 'Close detail') {
            documentiAperti++;
          }
        })
        if (documentiAperti === this.documents.length && this.documents.length > 1) {
          this.isTabellaDetailConUnElemento = true;
          this.documents.forEach(doc => {
            doc.metadatiDtoViewList.splice(3, 2);
          });
        }
        break;
      }
      case 'link': {
        this.docApertiLink++;
        let documentiAperti = 0;
        this.isExpandedLink = true;
        this.documentiCollegati.forEach(doc => {
          if (doc.isNewRevisionPending) {
            this.isTabellaLinkRevisionPending = true;
          }
          if (doc.codice == codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            doc.metadatiDtoViewList = doc.metadatiDtoList;
            if (this.documentiCollegati.length > 1) {
              const y = { key: '', value: '' };
              doc.metadatiDtoViewList.splice(3, 0, y);
              doc.metadatiDtoViewList.splice(4, 0, y);
              if (this.isTabellaLinkRevisionPending) {
                doc.metadatiDtoViewList.splice(5, 0, y);
              }
            } else {
              this.isTabellaLinkConUnElemento = true;
            }
            doc.apriDettaglio = 'Close detail';
          }
        });
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio === 'Close detail') {
            documentiAperti++;
          }
        });
        if (documentiAperti === this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = true;
          this.documentiCollegati.forEach(doc => {
            const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
            doc.metadatiDtoViewList.splice(3, spl);
          });
        }
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }

  closeDocumentDetail = (descr, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {

    switch (tipoDiTabella) {
      case 'detail': {
        let documentiApertiFull = 0;
        this.documents.forEach(doc => {
          if (doc.apriDettaglio === 'Close detail') {
            documentiApertiFull++;
          }
        })
        if (documentiApertiFull === this.documents.length && this.documents.length > 1) {
          this.isTabellaDetailConUnElemento = false;
          this.documents.forEach(doc => {
            const y = { key: '', value: '' };
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
          })
        }
        this.docApertiDetail--;
        this.documents.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            if (this.documents.length > 1) {
              doc.metadatiDtoViewList.splice(3, 2);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = 'Open detail';
          }
        })
        if (this.docApertiDetail === 0) {
          this.isExpandedDetail = false;
        }
        break;
      }
      case 'link': {
        let documentiApertiFull = 0;
        this.documentiCollegati.forEach(doc => {
          if (doc.apriDettaglio === 'Close detail') {
            documentiApertiFull++;
          }
        });
        if (documentiApertiFull === this.documentiCollegati.length && this.documentiCollegati.length > 1) {
          this.isTabellaLinkConUnElemento = false;
          this.documentiCollegati.forEach(doc => {
            const y = { key: '', value: '' };
            doc.metadatiDtoViewList.splice(3, 0, y);
            doc.metadatiDtoViewList.splice(4, 0, y);
            if (this.isTabellaLinkRevisionPending) {
              doc.metadatiDtoViewList.splice(5, 0, y);
            }
          });
        }
        this.docApertiLink--;
        this.documentiCollegati.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            if (this.documentiCollegati.length > 1) {
              const spl = this.isTabellaLinkRevisionPending ? 3 : 2;
              doc.metadatiDtoViewList.splice(3, spl);
            }
            doc.metadatiDtoViewList = doc.metadatiDtoShortList;
            doc.apriDettaglio = 'Open detail';
          }
        })
        if (this.docApertiLink === 0) {
          this.isExpandedLink = false;
        }
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }

  aggiungiAiPreferiti = (idDocumento, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case 'link': {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            doc.isDocPreferito = true;
          }
        });
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log('Preferite ' + idDocumento + ' Added');
          }
        });
        break;
      }
      case 'detail': {
        this.documents.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            doc.isDocPreferito = true;
          }
        });
        const url = 'api/rest/SetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Added");
          }
        })
        break;
      }
    }
  }

  togliDaiPreferiti = (idDocumento, codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {
    switch (tipoDiTabella) {
      case "link": {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        })
        break;
      }
      case "detail": {
        this.documents.forEach(doc => {
          if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
            doc.isDocPreferito = false;
          }
        })
        const url = 'api/rest/UnSetDocumentiPreferiti';
        const input = { idDocumento };
        this.documentService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log("Preferite " + idDocumento + " Unset");
          }
        });
        break;
      }

    }
  }

  openCalendar = () => {
    this.isCalendar = !this.isCalendar;
  }

  selectDate = () => {
    let now = new Date();
    this.selectedDate = new Date(this.calendarModel.year, this.calendarModel.month - 1, this.calendarModel.day, now.getHours(), now.getMinutes(), 0, 0);
  }

  onResultClickedEvidenze = () => {
    if (this.DescrizioneEvidenza && this.OggettoEvidenza) {
      this.isOkDescrizione = true;
      this.isOkOggetto = true;
      let selectedDateString = '';
      if (this.selectedDate != null && this.selectedDate != undefined) {
        selectedDateString = this.selectedDate.toDateString();
      } else {
        selectedDateString = '';
      }
      const send = this.showResultEvidenze(this.DescrizioneEvidenza, this.OggettoEvidenza, this.paginaIDDocumentoCorrente, this.paginaCommittenteDocumentoCorrente, selectedDateString);
      return send;
    } else {
      if (!this.DescrizioneEvidenza && this.OggettoEvidenza) {
        this.isOkDescrizione = false;
        this.isOkOggetto = true;
      }
      if (this.DescrizioneEvidenza && !this.OggettoEvidenza) {
        this.isOkOggetto = false;
        this.isOkDescrizione = true;
      }
      if (!this.DescrizioneEvidenza && !this.OggettoEvidenza) {
        this.isOkOggetto = false;
        this.isOkDescrizione = false;
      }
    }
  }

  showResultEvidenze = (DescrizioneEvidenza: string, OggettoEvidenza: string, iddocumento: string, destinatarioEvidenza: string, dataScadenza: string) => {
    this.labelNoRecord = false;

    const url = 'api/rest/CreaEvidenza';

    const input = { descrizione: DescrizioneEvidenza, oggetto: OggettoEvidenza, iddocumento: iddocumento, destinatari: destinatarioEvidenza, datascadenza: dataScadenza };
    this.creaEvidenzaService.postData(url, input, false).subscribe(result => {


      if (result['risultato'] === 'OK') {
        this.OggettoEvidenza = '';
        this.DescrizioneEvidenza = '';
        this.isCalendar = false;
        console.log('result' + result);
        alert("Evidence created");
        /* Refresh della lista Evidenze */
        const url = 'api/rest/GetEvidenzeByIdDocumento';
        const input = { iddocumento: iddocumento };
        this.evidenzaService.postData(url, input, false).subscribe(result => {
          if (result) {
            console.log('this is evidenze : ', result);
            this.evidenze = result as Evidenza[];
            this.labelNoRecord = true;
            this.myInputVariable.nativeElement.value = '';
          }
        });
      } else {
        alert("an error occurred during the creation of the evidence");
      }
    })
  }

  onFileSelected(event) {
    this.buttonEvidenzaActive = false;
    const file: File = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('thumbnail', file);
      formData.append('iddocumento', this.paginaIDDocumentoCorrente);
      const upload$ = this.http.post('/api/rest/thumbnail-upload', formData);
      upload$.subscribe(result => {
        this.buttonEvidenzaActive = true;
      }, error => console.log(error));
    }
  }


  tabMenuAllegato = (codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella) => {

    switch (tipoDiTabella) {
      case 'detail': {
        this.documents.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            doc.ismenuAllegato = !doc.ismenuAllegato;
            const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
            doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        })
        break;
      }
      case 'link': {
        this.documentiCollegati.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {
            doc.ismenuAllegato = !doc.ismenuAllegato;
            const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
            doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
          }
        });
        break;
      }
      default: {
        //statements;
        break;
      }
    }

  }

  tabMenuAllegatoSecondario = (doc: Documento) => {
    //debugger;
    this.modalService.open(doc.allegatiSecondariDtoList, doc.idDocumento);

  }



  tabMenuAllegatoSecondarioList = (codice, tipodocumento, revisione, identificazioneDocumento, tipoDiTabella, allegatoSecondario) => {

    switch (tipoDiTabella) {
      case 'detail': {
        this.documents.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione === revisione) {

            doc.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile === allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }

            })
          }
        })
        break;
      }
      case 'link': {
        this.documents.forEach(doc => {
          if (doc.codice === codice && doc.tipoDocumento === tipodocumento && doc.revisione == revisione) {

            doc.allegatiSecondariDtoList.forEach(all => {
              if (all.nomeFile === allegatoSecondario) {
                all.isTabOpened = !all.isTabOpened;
              } else {
                all.isTabVisualizated = !all.isTabVisualizated;
              }

            });
          }
        });
        break;
      }
      default: {
        //statements;
        break;
      }
    }

  }

  dataURIToBlob = (dataURI, mimeString) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result);
    })
  }

  getArcadocAttach(item: AttachmentDto, iddocumento, download: boolean, document: Documento) {
    const url = 'api/rest/GetAttachment';
    const needPresaVisione = this.documentService.isLegalEntityComplianceAssociated(document);
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download,
        needPresaVisione: needPresaVisione
      }
    };

    this.fileServer.getData(url, params, false).toPromise().then(res => {
      const attachment: AttachmentDto = res as AttachmentDto;

      if (needPresaVisione && attachment.presaVisione === false) {
        this.presaVisioneModalService.open(params.params.idDocument,
          params.params.idAllegato, params.params.download, params.params.fileName);
        return;
      }

      if (!this.hasAttachmentData(attachment)) {
        console.log("Impossibile recuperare l'allegato!");
        alert("Impossibile recuperare l'allegato!");
        return;
      }

      this.openAttachment(attachment, download);
    });
  }

  private openAttachment(attachment: AttachmentDto, download: boolean): void {
    const ext = attachment.nomeFile.split('.').pop();
    const downloadLink = document.createElement("a");
    const fileName = attachment.nomeFile;

    this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob => {
      const url = URL.createObjectURL(blob);
      if (download) {
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        window.open(url, '_blank')
      }
    })
  }

  private hasAttachmentData(attachment: AttachmentDto): boolean {
    return attachment != null && typeof attachment.data === 'string' && attachment.data.trim() !== '';
  }

}
